import { Subscription } from "@/features/Profile/Subscription/Subscription";

const SubscriptionView = () => <Subscription />;

export default SubscriptionView;
